export default __webpack_public_path__ + "images/7a4fb0fc57af9b6995b20ee607bcccee.png";